/** Orașul din jurul lotului pe planul de situație, în tonurile machetei
 *  (`culori.ts`): clădirile albe, gri deschis sau gri închis după cât de
 *  sigură e înălțimea lor, străzile, verdele și apa.
 *
 *  E un FUNDAL al ecranului, nu o parte a planșei: stă lângă `SitePlanView`,
 *  nu în el, deci exportul planșei rămâne cum era. De aceea poate folosi și
 *  `vector-effect`, pe care exportorul PDF nu-l are (v. `siteGlyphs.tsx`).
 *
 *  Se pune SUB planul lotului: lotul se umple cu hârtie, deci ce trece din
 *  oraș peste limită (o stradă, un parc) se oprește la ea. Clădirile de pe
 *  lot nu vin deloc (`orasInCadru`). `pointerEvents="none"`: un clic alege
 *  ce e pe lot, nu strada de dedesubt. */

import { memo, useMemo } from "react";
import { culoareCss } from "./culori";
import { caiOras, CLADIRI_2D, SOL_2D } from "./desen2d";
import type { Oras3 } from "./tipuri";

/** Grosimea conturului clădirilor, în pixeli de ecran, la orice zoom. */
const CONTUR_PX = 0.6;

function StratOras2D({ oras }: { oras: Oras3 }) {
  const cai = useMemo(() => caiOras(oras), [oras]);
  return (
    <g className="oras-2d" pointerEvents="none">
      {SOL_2D.map((k) => cai[k] && <path key={k} d={cai[k]} fill={culoareCss(k)} />)}
      {/* `vector-effect` nu se moștenește: stă pe fiecare cale */}
      <g stroke={culoareCss("contur")} strokeWidth={CONTUR_PX} strokeLinejoin="round">
        {CLADIRI_2D.map((k) => cai[k] && (
          <path key={k} d={cai[k]} fill={culoareCss(k)} vectorEffect="non-scaling-stroke" />
        ))}
      </g>
    </g>
  );
}

export default memo(StratOras2D);
